import { useUserData } from 'components/user/hooks/use-user-data';
import app from 'srcJs/App';
import * as React from 'react';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import classNames from 'classnames';

var UserPanelBalance = function UserPanelBalance() {
  var userData = useUserData();

  var renderBalance = function renderBalance() {
    if (!userData.balanceData.hasCreditLimit) {
      return /*#__PURE__*/React.createElement("div", {
        className: "fs-16 lh-1 font-weight-bold text-dark"
      }, userData.balanceData.valueFormat);
    }

    return /*#__PURE__*/React.createElement(PopoverStickOnHover, {
      text: userData.balanceData.tooltip,
      asHtml: true,
      placement: "bottom",
      popoverProps: {
        bsPrefix: 'popover popover_full-width'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('fs-16 lh-1 font-weight-bold', {
        'text-danger': userData.balanceData.isNegative
      }, {
        'text-dark': !userData.balanceData.isNegative
      })
    }, userData.balanceData.valueFormat));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-header__balance"
  }, renderBalance(), /*#__PURE__*/React.createElement("div", {
    className: "color-858585 fs-14"
  }, app.tForReact('base', 'Balance')));
};

export { UserPanelBalance };